var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiredLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.23,
    height: 127.039,
    viewBox: "0 0 137.23 127.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-323.77 -348.961)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1034.5 836.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    fill: "none",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    transform: "translate(-632.5 -419.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "none",
    stroke: "#8896A3",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M-574.5-390A28.5,28.5,0,0,1-603-361.5,28.5,28.5,0,0,1-631.5-390,28.5,28.5,0,0,1-603-418.5a28.448,28.448,0,0,1,9.6,1.656"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "#5CC7DB",
    d: "M-603.7-408.179h0a.851.851,0,0,1,.85.85v18.646a.851.851,0,0,1-.85.85h0a.851.851,0,0,1-.85-.85v-18.646A.851.851,0,0,1-603.7-408.179Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "#5CC7DB",
    d: "M-604.026-389.175a.917.917,0,0,1,1.3,0h0L-589.554-376a.917.917,0,0,1,0,1.3.917.917,0,0,1-1.3,0l-13.174-13.174a.919.919,0,0,1,0-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    fill: "#8896A3",
    d: "M-639.254-464.016A13.014,13.014,0,0,1-626-451.25q.009.482-.018.963a12.7,12.7,0,0,1-3.808,8.471q-6.437,6.449-12.885,12.885a12.986,12.986,0,0,1-18.2.068,1.217,1.217,0,0,1-.4-1.294,1.134,1.134,0,0,1,.937-.826,1.257,1.257,0,0,1,1.144.431,10.154,10.154,0,0,0,5.454,2.81,10.338,10.338,0,0,0,9.448-2.942c3.772-3.725,7.5-7.492,11.25-11.242.537-.537,1.087-1.061,1.608-1.613a10.232,10.232,0,0,0,2.505-10.92,10.027,10.027,0,0,0-8.632-7.063,10.092,10.092,0,0,0-8.833,2.974c-3.233,3.19-6.424,6.422-9.641,9.628a2.264,2.264,0,0,1-.736.523,1.133,1.133,0,0,1-1.351-.5,1.162,1.162,0,0,1,.177-1.467c.944-.958,1.9-1.9,2.852-2.855,2.346-2.345,4.681-4.7,7.039-7.031A12.637,12.637,0,0,1-639.254-464.016Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    fill: "#8896A3",
    d: "M-657.885-445.074a12.936,12.936,0,0,1,8.99,3.642,1.86,1.86,0,0,1,.454.641,1.153,1.153,0,0,1-.475,1.363,1.21,1.21,0,0,1-1.446-.118c-.424-.364-.826-.758-1.275-1.088a10.554,10.554,0,0,0-13.686.986c-4.1,4.071-8.225,8.128-12.253,12.274a10.035,10.035,0,0,0-2.436,10.889,10.042,10.042,0,0,0,8.638,7.006,10.168,10.168,0,0,0,8.889-3.042c2.735-2.709,5.443-5.445,8.176-8.155a1.8,1.8,0,0,1,.814-.446,1.072,1.072,0,0,1,1.171.577,1.16,1.16,0,0,1-.1,1.314,2.343,2.343,0,0,1-.246.262q-4.083,4.084-8.167,8.165a12.984,12.984,0,0,1-18.362.028,12.961,12.961,0,0,1-2.112-2.763,12.947,12.947,0,0,1,1.882-15.354q6.218-6.355,12.573-12.576A12.629,12.629,0,0,1-657.885-445.074Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "#5CC7DB",
    d: "M-637.866-423.271h3.077a1.2,1.2,0,0,1,1.3,1.1c0,.037,0,.074,0,.111a1.2,1.2,0,0,1-1.234,1.175l-.066,0q-3.1.008-6.193,0a1.206,1.206,0,0,1-1.314-1.086c0-.035-.005-.071-.005-.107a1.2,1.2,0,0,1,1.206-1.194,1.038,1.038,0,0,1,.112.006C-639.943-423.274-638.9-423.271-637.866-423.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "#5CC7DB",
    d: "M-666.953-456.368v-3.075a1.193,1.193,0,0,1,1.04-1.327,1.337,1.337,0,0,1,.167-.008,1.19,1.19,0,0,1,1.177,1.2,1.116,1.116,0,0,1-.008.129v6.151a1.2,1.2,0,0,1-1.072,1.316,1.089,1.089,0,0,1-.114.006,1.2,1.2,0,0,1-1.2-1.2,1.1,1.1,0,0,1,.006-.114C-666.956-454.318-666.953-455.343-666.953-456.368Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "#5CC7DB",
    d: "M-645.285-412.406v3.075a1.2,1.2,0,0,1-1.1,1.3c-.034,0-.069,0-.1,0a1.2,1.2,0,0,1-1.173-1.226c0-.025,0-.05,0-.074,0-2.077-.01-4.153,0-6.23a1.188,1.188,0,0,1,1.094-1.275,1.189,1.189,0,0,1,.7.165,1.168,1.168,0,0,1,.579,1.069C-645.288-414.536-645.285-413.471-645.285-412.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "#5CC7DB",
    d: "M-674.172-456.767a2.545,2.545,0,0,1,.686.385q2.281,2.236,4.523,4.513a1.18,1.18,0,0,1,.032,1.667l-.018.018a1.17,1.17,0,0,1-1.652.027l-.033-.034q-2.286-2.26-4.547-4.545a1.123,1.123,0,0,1-.234-1.327A1.257,1.257,0,0,1-674.172-456.767Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "#5CC7DB",
    d: "M-637.928-411.982a3.413,3.413,0,0,1-.808-.442q-2.281-2.233-4.524-4.51a1.188,1.188,0,0,1-.043-1.68l.036-.036a1.186,1.186,0,0,1,1.676.027l.011.012q2.27,2.248,4.517,4.517a1.134,1.134,0,0,1,.248,1.326A1.346,1.346,0,0,1-637.928-411.982Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "#5CC7DB",
    d: "M-674.357-445.555h-3.073a1.176,1.176,0,0,1-1.294-1.043,1.164,1.164,0,0,1-.006-.145,1.172,1.172,0,0,1,1.165-1.179,1.145,1.145,0,0,1,.117.005q3.113-.008,6.226,0a1.189,1.189,0,0,1,1.288,1.081,1.146,1.146,0,0,1,0,.131,1.194,1.194,0,0,1-1.232,1.155c-.026,0-.052,0-.078-.005C-672.281-445.552-673.319-445.555-674.357-445.555Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    stroke: "#8896A3",
    strokeLinecap: "round",
    strokeWidth: "2px",
    strokeMiterlimit: 10,
    d: "M-603.73-433.539a53.008,53.008,0,0,1-2.209,15.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    fill: "none",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeWidth: "2px",
    strokeMiterlimit: 10,
    d: "M-610.276-459.074a52.7,52.7,0,0,1,3.254,7.107"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    fill: "none",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeWidth: "2px",
    strokeMiterlimit: 10,
    d: "M-627.8-477.955a53.283,53.283,0,0,1,12.037,10.784"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    fill: "none",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeWidth: "2px",
    strokeMiterlimit: 10,
    d: "M-644.633-485.152a52.714,52.714,0,0,1,16.83,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    stroke: "#8896A3",
    strokeLinecap: "round",
    strokeWidth: "2px",
    strokeMiterlimit: 10,
    d: "M-644.633-485.152"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    stroke: "#8896A3",
    strokeLinecap: "round",
    strokeWidth: "2px",
    strokeMiterlimit: 10,
    d: "M-656.73-486.539"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    stroke: "#8896A3",
    strokeLinecap: "round",
    strokeWidth: "2px",
    strokeMiterlimit: 10,
    d: "M-631.467-386.936a52.76,52.76,0,0,1-25.263,6.4,53,53,0,0,1-53-53,53,53,0,0,1,53-53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    fill: "#5CC7DB",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M-589.285-414.658a22.083,22.083,0,0,1,8.029,6.479"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    fill: "#5CC7DB",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M-577.792-403.059a7.713,7.713,0,0,1,1.232,3.045"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredLink);
export default __webpack_public_path__ + "static/media/expired_link.69c10423.svg";
export { ForwardRef as ReactComponent };